var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.742,
    height: 64,
    viewBox: "0 0 63.742 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4002f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0804b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consultancy",
    transform: "translate(-0.54 -0.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M5568.6-586.567a2.059,2.059,0,0,1-2.059-2.059v-26.763a2.059,2.059,0,0,1,2.059-2.059h8.379a2.058,2.058,0,0,1,2.059,2.059v2.443l2.657-2.135a2.052,2.052,0,0,1,1.276-.452H5601.5a6.464,6.464,0,0,1,6.176,4.632l5.744,1.812,5.25-3.973a7.268,7.268,0,0,1,9.038.247,7.225,7.225,0,0,1,2.555,4.982,7.23,7.23,0,0,1-1.772,5.312L5616.9-589.284a2.059,2.059,0,0,1-1.585.721h-32.343a2.046,2.046,0,0,1-1.071-.35l-2.862-1.869v2.157a2.058,2.058,0,0,1-2.059,2.059Zm2.06-4.118h4.262v-3.825c0-.022,0-.043,0-.065v-14.145c0-.011,0-.022,0-.033v-4.578h-4.262Zm12.928-2h30.882l10.932-12.6a3.1,3.1,0,0,0,.754-2.271,3.11,3.11,0,0,0-1.084-2.135,3.107,3.107,0,0,0-4.055-.1l-6.176,4.632a2.062,2.062,0,0,1-1.853.329l-5.744-1.792a6.464,6.464,0,0,1-5.991,4.118h-7a2.058,2.058,0,0,1-2.059-2.059,2.059,2.059,0,0,1,2.059-2.059h7.227a2.346,2.346,0,0,0,2.128-2.336,2.347,2.347,0,0,0-2.128-2.337h-17.788l-4.653,3.562v12.043Zm27.773-19.538-5.826-5.538a16.779,16.779,0,0,1-19.905-8.409,16.78,16.78,0,0,1,4.886-21.049A16.78,16.78,0,0,1,5612.087-646a16.781,16.781,0,0,1,2.484,21.466l.267,10.787a2.058,2.058,0,0,1-2.059,2.059v.041A2.05,2.05,0,0,1,5611.36-612.219Zm-3.912-9.388,3.068,3.089-.165-6.465a2.054,2.054,0,0,1,.37-1.359,12.6,12.6,0,0,0-.04-14.833,12.6,12.6,0,0,0-14.129-4.516,12.6,12.6,0,0,0-8.636,12.06,12.6,12.6,0,0,0,8.826,11.922,12.353,12.353,0,0,0,8.441-.31,2.068,2.068,0,0,1,.762-.144l.082-.02A2.056,2.056,0,0,1,5607.448-621.608Z",
    transform: "translate(-5566 651)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.c74eb8249bcf82730d4159294cdbe8ef.svg";
export { ForwardRef as ReactComponent };